"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.journey = void 0;
exports.journey = {
    errors: {
        notEmptyTime: "{{name}} time should be not be empty",
    },
};
